import styled from 'styled-components';

interface IWrapperProps {
  valueType: 'customer' | 'docType';
}

export const SWrapper = styled.div<IWrapperProps>`
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  box-shadow: 0 3px 15px rgb(0 0 0 / 0.2);
  display: flex;
  height: auto;
  max-height: 450px;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  width: 50%;
  z-index: 1081;

  ${({ valueType }) => {
    if (valueType === 'docType') {
      return `
      float: right;
      `;
    }
  }}
`;

export const SSection = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;

  display: flex;
  flex-direction: column;
`;

export const SHorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  position: absolute;
  top: 80px;

  background-color: ${({ theme }) => theme.colors.primaryBackground};
`;

export const SScrollableContainer = styled.div`
  overflow: hidden;

  overflow-y: auto;
`;

export const SVerticalDivider = styled.div`
  width: 1px;
  height: 100%;

  background-color: ${({ theme }) => theme.colors.primaryBackground};
`;
